export default __webpack_public_path__ + "static/media/COMMUNITY OF WOMEN.0f3e9b2f.png";